import {GameView} from "../base/GameView";
import {GameDialog} from "../base/GameDialog";

export class UILayer extends GameView {
    override onResize() {
        for (let i = this.children.length - 1; i >= 0; i--) {
            let child = this.getChildAt(i);
            if(child instanceof GameView) {
                let gameView = child as GameView;
                gameView.onResize();
            }
        }
    }
}
